// Moved from not-jquery library.
// This function looks for a property (searchKey) in an object (obj).
// It searches deep, so it's recursive.

function objectPathToKey(obj, searchKey, currentPath = '') {

  var result = null;

  if (obj instanceof Array) {

    for (var i = 0; i < obj.length; i++) {

      result = objectPathToKey(obj[i], searchKey, currentPath + '[' + i + ']');

      if (result !== null) {
        return result;
      }
    }
  } else if (obj instanceof Object) {

    if (obj.hasOwnProperty(searchKey)) {
      const objValue = obj[searchKey];
      if(typeof objValue === 'object') {
        const returnObject = {
          object : objValue,
          path   : currentPath + '.' + searchKey
        };
  
        return returnObject;
      }
    }

    for (var prop in obj) {

      if (typeof obj[prop] !== 'undefined' && obj[prop] !== null) {

        var constructor = obj[prop].constructor;

        if (constructor === {}.constructor || constructor === [].constructor) {

          result = objectPathToKey(obj[prop], searchKey, currentPath + '.' + prop);

          if(result !== null) {
            return result;
          }
        }
      }
    }

  }

  return result;
}

module.exports = objectPathToKey;
